import { AxiosError } from 'axios';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Stack, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ICreateCustomerReq } from '../../../commons/interfaces/customer.interface';
import { Unit } from '../../../commons/interfaces/unit.interface';
import Paper from '../../../components/Paper';
import PublicFormInput from '../../../components/PublicFormInput';
import useAPIError from '../../../hooks/apiError.context';
import usePublicForm from '../../../hooks/publicForm.hook';
import ChatbotAPI from '../../../services/chatbot.service';
import PublicService from '../../../services/public.service';

const chatbotApi = new ChatbotAPI();
const publicService = new PublicService();

const CustomerRegisterForm = () => {
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<ICreateCustomerReq>({ criteriaMode: 'all' });
  const { setStep, setCustomer } = usePublicForm();
  const { addError } = useAPIError();

  const [units, setUnits] = useState<Unit[]>([]);

  useEffect(() => {
    const fetchUnits = async () => {
      const response = await chatbotApi.listUnits();
      setUnits(response.data.data);
    };

    fetchUnits();
  }, []);

  const getUnits = () => {
    return _.map(units, (unit) => unit.name);
  };

  const onSubmit = async (data: ICreateCustomerReq) => {
    const requestData = {
      ...data,
      number: '51' + data.number,
      unit: units[+data.unit].id
    };

    try {
      const response = await publicService.createCustomer(requestData);

      setCustomer(response.data);
      setStep(3);
    } catch (err) {
      if (err instanceof AxiosError) {
        const { response } = err;
        addError(response?.data.message, 'danger');
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Stack gap={3}>
        <Paper className="form-title">
          <div className="mb-2">
            <span className="text-title">Registro de cliente</span>
          </div>
          <div>
            <p>
              Con el fin de poder acelerar el proceso para la solicitud del formulario, brindenos la
              informacion requerida para el registro del cliente asociado a su numero telefonico.
            </p>
          </div>
        </Paper>
        <PublicFormInput
          register={register}
          questionId="number"
          question="Ingrese su número telefónico"
          type="TEXT"
          errors={errors}
        />
        <PublicFormInput
          register={register}
          questionId="name"
          question="Ingrese su nombre completo"
          type="TEXT"
          errors={errors}
        />
        <PublicFormInput
          register={register}
          questionId="email"
          question="Ingrese su correo electrónico"
          type="EMAIL"
          errors={errors}
        />
        <PublicFormInput
          register={register}
          questionId="ruc"
          question="Ingreso el numero RUC de la empresa a la que pertenece"
          type="TEXT"
          errors={errors}
        />
        <PublicFormInput
          register={register}
          questionId="unit"
          question="Selecione la unidad a la que pertenece"
          type="SELECT"
          errors={errors}
          options={getUnits()}
        />
        <div className="form-footer">
          <Button variant="primary" type="submit">
            Validar
          </Button>
        </div>
      </Stack>
    </form>
  );
};

export default CustomerRegisterForm;
